import { render } from "./mix-selectors.vue?vue&type=template&id=1c896566&scoped=true&ts=true"
import script from "./mix-selectors.vue?vue&type=script&lang=ts"
export * from "./mix-selectors.vue?vue&type=script&lang=ts"

import "./mix-selectors.vue?vue&type=style&index=0&id=1c896566&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c896566"]])

export default __exports__